import Vue from 'vue'
import Router from 'vue-router'
import defIndex from '@/components/index/index'
import end from '@/components/index/end'
import albumIndex from '@/components/album/index'
import companyIndex from '@/components/company/index'
import companyView from '@/components/company/view'
import companyPreview from '@/components/company/preview'
import photoIndex from '@/components/photo/index'
import photoBrowse from '@/components/photo/browse'
import frameIndex from '@/components/album/frame'
import authlogin from '@/components/users/authlogin'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: defIndex
    },
    {
      path: '/end',
      name: 'end',
      component: end
    },
    {
      path: '/album/index',
      name: 'album',
      component: albumIndex
    },
    {
      path: '/company/index',
      name: 'company',
      component: companyIndex
    },
    {
      path: '/photo/index',
      name: 'photo',
      component: photoIndex
    },
    {
      path: '/photo/browse',
      name: 'photoBrowse',
      component: photoBrowse
    },
    {
      path: '/album/frame',
      name: 'frame',
      component: frameIndex
    },
    {
      path: '/company/view',
      name: 'companyView',
      component: companyView
    },
    {
      path: '/company/preview',
      name: 'companyPreview',
      component: companyPreview
    },
    {
      // 接受登录数据
      path: '/users/authlogin/:jwt/:id/:val',
      name: 'authlogin',
      component: authlogin
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js